import UserEvent from "../event/UserEvent"
import { UserEventDecorator } from "../user/UserEventDecorator"
import SessionUserDecorator from "./SessionUserDecorator"

export default class SessionUserEventDecorator implements UserEventDecorator {
  constructor(private readonly sessionUserDecorator: SessionUserDecorator) {}

  decorate(event: UserEvent): UserEvent {
    const user = this.sessionUserDecorator.decorate(event.user)
    return event.copyWithUser(user)
  }
}
